import { Paper } from "@mui/material";
import Card from "components/Dashboard/Card";

export default function Taxes(props) {
  return (
    <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
      <Card
        label="Property Taxes"
        activeKey="taxes"
        row={
          props.estatedProperty.taxes.length
            ? props.estatedProperty.taxes[0]
            : undefined
        }
      />
    </Paper>
  );
}
